import * as React from 'react'
import { ArrowUp } from 'lucide-react'
import { useLanguage } from '../contexts/LanguageContext'

const GoToTop: React.FC = () => {
  const { isRTL } = useLanguage()
  const [showGoToTop, setShowGoToTop] = React.useState(false)

  // Handle scroll to show/hide go to top button
  React.useEffect(() => {
    const handleScroll = () => {
      setShowGoToTop(window.scrollY > 300)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  if (!showGoToTop) return null

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-10 z-50 w-12 h-12 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 items-center justify-center group hidden md:flex ${isRTL ? 'left-10' : 'right-10'}`}
      style={{ backgroundColor: '#0075c9' }}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#005a9e'}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0075c9'}
      aria-label="Go to top"
    >
      <ArrowUp className="w-6 h-6" />
    </button>
  )
}

export default GoToTop
